import { Injectable } from '@angular/core';
import { collection, where, onSnapshot, Unsubscribe, query } from '@firebase/firestore';
import { AngularFirestore,  } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Subject } from 'rxjs';
import { LoadingService } from '../loading.service';
import { Events } from './events';


@Injectable({
  providedIn: 'root'
})
export class EventsService {

  
  constructor(public firestore: AngularFirestore, private storage: AngularFireStorage, public loadingService: LoadingService) { this.getEvents() }
  
  keepFocus = false
  addingNewEvent = false
  selectedEvent?: Events
  db = this.firestore.firestore
  eventsListener?: Unsubscribe
  private allEvents = new Subject<any>();
  public allEvents$ = this.allEvents.asObservable();
  // private eventIsBeingEdited = new Subject<any>();
  // public eventIsBeingEdited$ = this.eventIsBeingEdited.asObservable();
  
  addEventCancelled() {
    this.addingNewEvent = false
    this.keepFocus = false
  }

  async addNewEvent(event: Events, loadingKey: string, file?: File) {
    const newEventDoc = this.db.collection("events").doc();
    var eventToPost = Object(event)

    delete event.uid

    if (file != null && file != undefined) {
        const fileExtension = this.returnFileType(file.name)
        const nameEncoded = event.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const fileName = `${nameEncoded}.${fileExtension}`
        const filePath = `eventPhotos/${fileName}`;
        const ref = this.storage.ref(filePath);
        await ref.put(file);
        eventToPost["eventFileName"] = fileName
    }

    newEventDoc.set(eventToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewEvent = false
      this.selectedEvent = undefined
      alert("Event added successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  async updateEvent(event: Events, newfile?: File) {
    const loadingKey = event.uid!!
    this.loadingService.addLoadingKey(loadingKey)
    const eventDoc = this.db.collection("events").doc(event.uid);
    
    var eventToPost = Object(event)
    delete eventToPost.uid

    if (newfile != null && newfile != undefined) {
        const fileExtension = this.returnFileType(newfile.name)
        const fileName = `${event.name}.${fileExtension}`
        const filePath = `eventPhotos/${fileName}`;
        const ref = this.storage.ref(filePath);
        await ref.put(newfile);
        eventToPost["picFileName"] = fileName
    }

    eventDoc.update(eventToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewEvent = false
      this.selectedEvent = undefined
      alert("Event Updated successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  getEvents() {
    if (this.eventsListener != null) {
      return
    }

    const q = query(collection(this.db, "events"));
    this.eventsListener = onSnapshot(q, (querySnapshot) => {
      const snapshotEvents: Events[] = []
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        const uid = doc.id
        const name = data["name"]
        const picFileName = data["picFileName"]
        const description = data["description"]

        const event = { uid, name, description, picFileName } as Events
        snapshotEvents.push(event)
      });
      snapshotEvents.sort((a, b) => a.name > b.name ? -1 : 1);
      this.allEvents.next(snapshotEvents)
    },
      (error) => {
        alert(error)
        throw(error)
      });;
  }

  async deleteEvent(event: Events) {
    const loadingKey = event.name
    this.loadingService.addLoadingKey(loadingKey)
    const eventDoc = this.db.collection("events").doc(event.uid);
    
    eventDoc.delete()
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewEvent = false
      this.selectedEvent = undefined
      alert("Event Removed successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  //FIXME: - fire this
  signout() {
    if (this.eventsListener != null) {
      this.eventsListener()
    }
  }

  returnFileType(fileName: string) {
    return fileName.split('.').pop();
  }
}
